/** Position stored on shift (historical) or fallback to employee's current role */
export function getShiftPosition(shift, employee) {
  if (shift?.position) return shift.position;
  if (employee?.position) return employee.position;
  return '';
}

/** Shifts belonging to a specific week (YYYY-MM-DD week_start) */
export function shiftsForWeek(shifts, weekStart) {
  if (!weekStart || !Array.isArray(shifts)) return [];
  return shifts.filter((s) => s.week_start === weekStart);
}

/** True when shift list is loaded for the requested week (empty week counts as ready) */
export function areShiftsReadyForWeek(shifts, weekStart, loading) {
  if (loading) return false;
  if (!Array.isArray(shifts) || shifts.length === 0) return true;
  return shifts.every((s) => s.week_start === weekStart);
}

/** Role for an employee in a given week — from shift snapshots, else current profile */
export function getEmployeeWeekPosition(employee, shifts, weekStart) {
  const weekShifts = shiftsForWeek(shifts, weekStart).filter((s) => s.employee_id === employee.id);
  if (weekShifts.length > 0) {
    return getShiftPosition(weekShifts[0], employee);
  }
  return employee?.position || '';
}

export function employeeMatchesPositionFilter(employee, shifts, selectedPosition, weekStart) {
  if (!selectedPosition) return true;
  const scopedShifts = weekStart ? shiftsForWeek(shifts, weekStart) : shifts;
  const empShifts = scopedShifts.filter((s) => s.employee_id === employee.id);
  if (empShifts.length > 0) {
    return empShifts.some((s) => getShiftPosition(s, employee) === selectedPosition);
  }
  return employee.position === selectedPosition;
}
